import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectPerimeterCameraLabelFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

import { perimeterCameraIconLabelLayer } from './perimeterCamera.layer';

function PerimeterCameraLabelLayerContent() {
  const perimeterCameraLabelFeatures = useSelectorWithReplayMode(selectPerimeterCameraLabelFeatures);

  if (!isFeatureCollection(perimeterCameraLabelFeatures)) return null;

  return (
    <Source id={SourceNameEnum.PERIMETER_CAMERA_LABELS} type="geojson" data={perimeterCameraLabelFeatures}>
      <Layer {...perimeterCameraIconLabelLayer} />
    </Source>
  );
}

export default function PerimeterCameraLabelLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.PERIMETER_CAMERA_LABELS)}>
      <PerimeterCameraLabelLayerContent />
    </ErrorBoundary>
  ) : (
    <PerimeterCameraLabelLayerContent />
  );
}
